<template>
      <div class="col-lg-6 mb-1">
        <div class="ibox-body">
          <div class="ibox-title style_2 d-flex justify-content-between">
            <h5>Fill New eCRF</h5>
            <div
            class="position-relative align-self-center"
            aria-label="Create subject"
            tabindex="0"
          >
            <img
              width="17"
              height="17"
              class="cursor-pointer"
              src="../../assets/img/create.png"
              alt="Create subject"
              @click="editPatient()"
            />
            <div class="tool-tip">{{ $t("navigations.create subject") }}</div>
          </div>
          </div>
          <div class="ibox-content horizondalscroll" :id="treeNodeId('enter', 'scrollBody')">
            <ul class="tree pl-1">
              <li v-for="(site, sIndex) in sites" :key="treeNodeId('enter', 'site-row', site.siteID)">
                <input type="checkbox" :id="treeNodeId('enter', 'site', site.siteID)"
                  @change="getpatient(site.siteID, sIndex, 'enter')" />
                <label class="tree_label" :for="treeNodeId('enter', 'site', site.siteID)">{{ site.siteCode
                  }}</label>
                <ul v-for="(patient, pIndex) in treeStates.enter.patientLists[sIndex]"
                  :for="treeNodeId('enter', 'site', site.siteID)"
                  :key="treeNodeId('enter', 'patient-row', patient.patientId)">
                  <li>
                    <input type="checkbox" :id="treeNodeId('enter', 'patient', patient.patientId)"
                      @change="getVisits(patient.patientId, pIndex, 'enter')" />
                    <label :for="treeNodeId('enter', 'patient', patient.patientId)" class="tree_label">{{
                      patient.subjectId }}</label>
                    <ul v-if="allFormList && allFormList.length">
                      <li v-for="form in allFormList"
                        :key="treeNodeId('enter', 'subject-form-row', form.templateId, patient.patientId)">
                        <input type="checkbox"
                          :id="treeNodeId('enter', 'subject-form', form.templateId, patient.patientId)" />
                        <label class="tree_label"
                          :for="treeNodeId('enter', 'subject-form', form.templateId, patient.patientId)">
                          <a @click.prevent="goToSubjectForm(form, patient.subjectId, site.siteID, patient.patientId)">
                            {{ form.templateName }} ( {{ form.version }}) - {{ form.languageCode.toUpperCase() }}
                          </a>
                        </label>
                      </li>
                    </ul>
                    <template v-if="!treeStates.enter.visitTreeObj?.[patient.patientId]?.length">
                      <ul v-for="(visit, vIndex) in treeStates.enter.visitobj[patient.patientId][pIndex]"
                        :for="treeNodeId('enter', 'patient', patient.patientId)"
                        :key="treeNodeId('enter', 'visit-row', visit.sheduleId, patient.patientId)">
                        <li>
                          <input type="checkbox" :id="treeNodeId('enter', 'visit', visit.sheduleId, patient.patientId)" @change="  getactivities(
                            patient.patientId,
                            visit.visitNo,
                            visit.visitName,
                            vIndex,
                            visit.sheduleId,
                            site.siteCode,
                            visit.patientNo,
                            'enter'
                          )" />
                          <label :for="treeNodeId('enter', 'visit', visit.sheduleId, patient.patientId)" class="tree_label">
                            {{ visit.visitNo }} - {{ visit.visitName }} - ( {{ setdate(visit) }} )
                            <span class="badge custom-tooltip-wrapper"
                              @mouseenter="showPopover(treePopoverId('enter', 'visitStatus', sIndex, pIndex, vIndex))"
                              @mouseleave="hidePopover(treePopoverId('enter', 'visitStatus', sIndex, pIndex, vIndex))"
                              :popovertarget="treePopoverId('enter', 'visitStatus', sIndex, pIndex, vIndex)"
                              :style="`background-color: ${visit.visitStatusHex}; color: black; anchor-name:--${treePopoverId('enter', 'visitStatus', sIndex, pIndex, vIndex)};`">
                              {{ visit.visitStatus }}</span><span class="custom-tooltip-text"
                              v-if="visit.visitStatusDescription" popover
                              :id="treePopoverId('enter', 'visitStatus', sIndex, pIndex, vIndex)"
                              :style="`position-anchor:--${treePopoverId('enter', 'visitStatus', sIndex, pIndex, vIndex)};`">{{
                                visit.visitStatusDescription }}</span>
                          </label>
                          <span v-if="roleprivileges.includes('Submit Form Add New Form') ||
                            roleprivileges.includes('Submit Form Video Call') ||
                            roleprivileges.includes('Submit Form Change Visit Status ')"
                            class="position-relative cursor-pointer float-right px-2"
                            @click.prevent="toggleSidePopup(sIndex, pIndex, vIndex, 'enter')"
                            v-on:clickout="closeSidePopup(sIndex, pIndex, vIndex, 'enter')">
                            <i class="fa fa-ellipsis-v"></i>
                          </span>
                          <div class="plan-side-popup" v-if="
                            showSidePopup['enter'] &&
                            showSidePopup['enter'][sIndex] &&
                            showSidePopup['enter'][sIndex][pIndex] &&
                            showSidePopup['enter'][sIndex][pIndex][vIndex]
                          ">
                            <div @click.prevent="
                              openPlanNextVisitModal(
                                treeStates.enter.visitobj[patient.patientId][pIndex][vIndex + 1],
                                pIndex,
                                'enter'
                              )
                              ">
                              Plan Next Visit
                            </div>
                            <div @click.prevent="openManageVisitPopup(visit, pIndex, 'enter')">
                              Manage Visit
                            </div>
                            <div v-if="roleprivileges.includes('Submit Form Add New Form')" @click.prevent="
                              openModal(visit, patient.subjectId, site.siteCode, visit.visitStatus, visit.visitNo, patient.patientId)
                              ">
                              {{ $t("navigations.new form") }}
                            </div>
                            <div v-if="roleprivileges.includes('Submit Form Video Call')"
                              @click.prevent="openVideoCallSchedulePopup(patient.patientId)">
                              Video Call
                            </div>
                            <div
                              v-if="visit.visitStatus != 'Completed' && roleprivileges.includes('Submit Form Change Visit Status')"
                              @click.prevent="openChangeStatusmodal(visit.studyId, visit.visitNo, patient.patientId, visit.visitStatus, vIndex, 'Visit', null, null, null, null, null, 'enter')">
                              {{ $t("navigations.change status") }}
                            </div>
                          </div>

                          <ul>
                            <li>
                              <input type="checkbox">
                              <label
                                @click.prevent="toggleObservationFolder(visit.siteCode, visit.patientNo, visit.visitName, visit.visitNo, patient.patientId, 'enter')"
                                class="tree_label">{{ $t("navigations.observations") }}</label>

                              <template v-if="treeStates.enter.categoryFlags[visit.visitNo + patient.patientId]">
                                <div v-for="docType in treeStates.enter.categoryFlags[visit.visitNo + patient.patientId]"
                                  :key="docType.id" class="tree-node mb-2">
                                  <div @click.prevent="docType.flag = !docType.flag">
                                    <span class="cursor-pointer">
                                      <i class="fa fa-file-code-o text-primary me-2"></i>
                                      {{ docType.category }}
                                    </span>
                                  </div>
                                  <div class="row" v-if="docType.flag == true">
                                    <div class="d-flex pt-2 pl-4 cursor-pointer" v-for="(value, index) in docType.code"
                                      :key="index"
                                      @click.prevent="selectDocument(site.siteCode, patient.subjectId, docType.document[index], visit.visitName, patient.patientId, patient.siteId)">
                                      <span class="mr-1">{{ value }}</span>
                                      <span v-if="docType.effectiveDateTime[index]">
                                        ({{ filterTimeFormat(docType.effectiveDateTime[index]) }})
                                      </span>
                                    </div>
                                  </div>


                                </div>
                              </template>


                            </li>
                          </ul>
                          <template
                            v-if="(treeStates.enter.activityobject?.[`${visit.visitNo}_${patient.patientId}`]?.[vIndex] || []).length">

                            <ul
                              v-for="(singleactivity, activityindex) in (treeStates.enter.activityobject?.[`${visit.visitNo}_${patient.patientId}`]?.[vIndex] || [])"
                              :key="singleactivity.activityId">
                              <li>
                                <input v-if="singleactivity.activityId"
                                  :id="treeNodeId('enter', 'activity', singleactivity.activityId, patient.patientId, visit.visitNo, singleactivity.activityOrder)"
                                  type="checkbox" @change="
                                    getFormsByVisit(patient.patientId,
                                      visit.visitNo,
                                      visit.visitName,
                                      vIndex,
                                      visit.sheduleId,
                                      activityindex,
                                      singleactivity.activityId,
                                      singleactivity.activityOrder,
                                      'enter'
                                    )
                                    " />
                                <label class="tree_label" @click.stop>
                                  <span @click.stop="
                                    getFormsByVisit(patient.patientId,
                                      visit.visitNo,
                                      visit.visitName,
                                      vIndex,
                                      visit.sheduleId,
                                      activityindex,
                                      singleactivity.activityId,
                                      singleactivity.activityOrder,
                                      'enter'
                                    )
                                    ">

                                    {{ singleactivity.activityName }}
                                    <span class="badge custom-form-tooltip-wrapper"
                                      :style="`background-color: ${singleactivity.statusHex}; color: black;`">
                                      {{ singleactivity.status }}</span>
                                  </span>
                                </label>
                                <button v-if="singleactivity.formStatus !== 'Completed'"
                                  :popovertarget="popoverId(singleactivity.activityId, sIndex, pIndex, vIndex, 'enter')"
                                  class="visit-ellipsis-btn py-0 px-3 float-right" @click.stop type="button">
                                  <i class="fa fa-ellipsis-v"></i>
                                </button>
                                <div :id="popoverId(singleactivity.activityId, sIndex, pIndex, vIndex, 'enter')" popover
                                  class="visit-popup-menu">
                                  <button @click.prevent.stop="
                                    openChangeStatusmodalforactivity(
                                      singleactivity.actScheduleId,
                                      singleactivity.status,
                                      patient.patientId,
                                      visit.visitNo,
                                      visit.visitName,
                                      vIndex,
                                      visit.sheduleId,
                                      popoverId(singleactivity.activityId, sIndex, pIndex, vIndex, 'enter'),
                                      'enter'
                                    )
                                    " class="popup-menu-block text-left w-100">
                                    {{ $t("navigations.change status") }}
                                  </button>

                                </div>
                                <template v-if="treeStates.enter.visitFormObj[visit.visitNo + patient.patientId]">
                                  <ul>
                                    <li v-for="singlevisit in treeStates.enter.visitFormObj[
                                      visit.visitNo + patient.patientId
                                    ][activityindex]" :key="singlevisit.sheduleId">

                                      <input v-if="singlevisit.templateName" type="checkbox" @click.prevent="
                                        gotoform(singlevisit, patient.subjectId, site.siteCode, visit.visitNo,
                                          patient.patientId)
                                        " />
                                      <label class="tree_label" @click.prevent>

                                        <div class="d-flex">

                                          <div class="d-flex align-items-center" @click.prevent.stop="
                                            gotoform(
                                              singlevisit,
                                              patient.subjectId,
                                              site.siteCode, visit.visitNo,
                                              patient.patientId
                                            )
                                            ">
                                            <p class="mb-0" style="max-width: 28ch;">
                                              {{
                                                // singlevisit.formStatus === "Completed"
                                                // ? singlevisit.templateName +
                                                // " - " +
                                                // (singlevisit.visitCompletedDate
                                                // ? filter(singlevisit.visitCompletedDate) + "-"
                                                // : "")
                                                // : singlevisit.templateName
                                                singlevisit.formStatus === 'Completed'
                                                  ? singlevisit.templateName + ' (' + singlevisit.version + ') - ' +
                                                  singlevisit.languageCode?.toUpperCase() +
                                                  ' - ' +
                                                  (singlevisit.visitCompletedDate
                                                    ? filter(singlevisit.visitCompletedDate) + '-'
                                                    : '')
                                                  : singlevisit.templateName + ' (' + singlevisit.version + ') - ' +
                                                  singlevisit.languageCode?.toUpperCase()
                                              }} </p>
                                            <span class="badge custom-form-tooltip-wrapper"
                                              @mouseenter="showPopover(treePopoverId('enter', 'formStatus', singlevisit.sheduleId, pIndex, vIndex, activityindex))"
                                              @mouseleave="hidePopover(treePopoverId('enter', 'formStatus', singlevisit.sheduleId, pIndex, vIndex, activityindex))"
                                              :popovertarget="treePopoverId('enter', 'formStatus', singlevisit.sheduleId, pIndex, vIndex, activityindex)"
                                              :style="`background-color: ${singlevisit.formStatusHex}; color: black; anchor-name:--${treePopoverId('enter', 'formStatus', singlevisit.sheduleId, pIndex, vIndex, activityindex)};`">
                                              {{ singlevisit.formStatus }}</span>
                                            <span v-if="singlevisit.formStatusDescription" popover
                                              class="custom-form-tooltip-text"
                                              :id="treePopoverId('enter', 'formStatus', singlevisit.sheduleId, pIndex, vIndex, activityindex)"
                                              :style="`position-anchor:--${treePopoverId('enter', 'formStatus', singlevisit.sheduleId, pIndex, vIndex, activityindex)};`">
                                              {{ singlevisit.formStatusDescription }}</span>
                                          </div>


                                          <button v-if="singlevisit.formStatus !== 'Completed'"
                                            :popovertarget="popoverId(singlevisit.sheduleId, sIndex, pIndex, vIndex, 'enter')"
                                            :anchor="popoverId('visitForms', sIndex, pIndex, vIndex, 'enter')"
                                            class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                            <i class="fa fa-ellipsis-v"></i>
                                          </button>
                                          <div :id="popoverId(singlevisit.sheduleId, sIndex, pIndex, vIndex, 'enter')" popover
                                            class="visit-popup-menu">
                                            <button @click.prevent.stop="
                                              openChangeStatusmodal(
                                                visit.studyId,
                                                visit.visitNo,
                                                patient.patientId,
                                                visit.visitStatus,
                                                vIndex,
                                                'Form',
                                                popoverId(singlevisit.sheduleId, sIndex, pIndex, vIndex, 'enter'),
                                                visit.visitName,
                                                singlevisit.formStatus,
                                                singlevisit.formId,
                                                singlevisit.sheduleId,
                                                'enter'
                                              )
                                              " class="popup-menu-block text-left w-100">
                                              {{ $t("navigations.change status") }}
                                            </button>
                                            <button v-if="roleprivileges.includes('Subject Schedule Change eCRF')"
                                              @click.prevent="
                                                ChangeTemplatePopup(
                                                  visit.studyId,
                                                  visit.visitNo,
                                                  patient.patientId,
                                                  visit.visitStatus,
                                                  vIndex,
                                                  'Form',
                                                  popoverId(singlevisit.sheduleId, sIndex, pIndex, vIndex, 'enter'),
                                                  visit.visitName,
                                                  singlevisit.formStatus,
                                                  singlevisit.sheduleId,
                                                  singlevisit.templateId
                                                )
                                                " class="popup-menu-block text-left w-100">
                                              {{ $t("navigations.change ecrf") }}
                                            </button>
                                          </div>
                                        </div>
                                      </label>
                                    </li>
                                  </ul>
                                </template>
                              </li>
                            </ul>
                          </template>

                        </li>
                      </ul>
                    </template>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
</template>
<script>
export default {
  name: "EnterNewEcrfTree",
  props: {
    sites: {
      type: Array,
      default: () => []
    },
    treeStates: {
      type: Object,
      required: true
    },
    allFormList: {
      type: Array,
      default: () => []
    },
    roleprivileges: {
      type: [Array, String],
      default: () => []
    },
    showSidePopup: {
      type: Object,
      default: () => ({})
    },
    handlers: {
      type: Object,
      required: true
    }
  },
  methods: {
    editPatient(){
this.$emit('editpatient')
    },
    callHandler(name, ...args) {
      const handler = this.handlers?.[name];
      return typeof handler === "function" ? handler(...args) : undefined;
    },
    treeIdPart(value) {
      return String(value == null ? "" : value).replace(/[^A-Za-z0-9_-]/g, "-");
    },
    treeNodeId(treeKey, ...parts) {
      return [treeKey, ...parts].map(part => this.treeIdPart(part)).join("-");
    },
    treePopoverId(treeKey, ...parts) {
      return this.treeNodeId(treeKey, "popover", ...parts);
    },
    popoverId(svisit, sIndex, pIndex, vIndex, treeKey = "enter") {
      return this.treePopoverId(treeKey, "menu", svisit, sIndex, pIndex, vIndex);
    },
    getpatient(...args) { return this.callHandler("getpatient", ...args); },
    getVisits(...args) { return this.callHandler("getVisits", ...args); },
    goToSubjectForm(...args) { return this.callHandler("goToSubjectForm", ...args); },
    getactivities(...args) { return this.callHandler("getactivities", ...args); },
    setdate(...args) { return this.callHandler("setdate", ...args); },
    showPopover(...args) { return this.callHandler("showPopover", ...args); },
    hidePopover(...args) { return this.callHandler("hidePopover", ...args); },
    toggleSidePopup(...args) { return this.callHandler("toggleSidePopup", ...args); },
    closeSidePopup(...args) { return this.callHandler("closeSidePopup", ...args); },
    openPlanNextVisitModal(...args) { return this.callHandler("openPlanNextVisitModal", ...args); },
    openManageVisitPopup(...args) { return this.callHandler("openManageVisitPopup", ...args); },
    openModal(...args) { return this.callHandler("openModal", ...args); },
    openVideoCallSchedulePopup(...args) { return this.callHandler("openVideoCallSchedulePopup", ...args); },
    openChangeStatusmodal(...args) { return this.callHandler("openChangeStatusmodal", ...args); },
    toggleObservationFolder(...args) { return this.callHandler("toggleObservationFolder", ...args); },
    selectDocument(...args) { return this.callHandler("selectDocument", ...args); },
    filterTimeFormat(...args) { return this.callHandler("filterTimeFormat", ...args); },
    getFormsByVisit(...args) { return this.callHandler("getFormsByVisit", ...args); },
    openChangeStatusmodalforactivity(...args) { return this.callHandler("openChangeStatusmodalforactivity", ...args); },
    gotoform(...args) { return this.callHandler("gotoform", ...args); },
    filter(...args) { return this.callHandler("filter", ...args); },
    ChangeTemplatePopup(...args) { return this.callHandler("ChangeTemplatePopup", ...args); }
  }
};
</script><style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
@import "../Submit_Form/tree.css";

.custom-tooltip-wrapper {
  position: relative
}

.custom-tooltip-text,
.custom-form-tooltip-text {
  position: absolute;
  inset: auto;
  margin: 0;
  bottom: anchor(top);
  right: anchor(right);
  background-color: #616161;
  color: white;
  padding: 6px 10px;
  font-size: 0.75rem;
  border-radius: 4px;
  border: none;
  max-width: 180px;
  white-space: normal;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-block-end: 4px;
}

.custom-tooltip-text:popover-open {
  display: grid;
}

.visit-ellipsis-btn {
  anchor-name: --manage-btn;
  border: 0;
}

.visit-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
  position-try-fallbacks: --bottom;
}

.visit-popup-menu>button {
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

.visit-popup-menu>.popup-menu-block:hover,
.popup-submenu>div:hover {
  background-color: #e4eaf9;
}

@position-try --bottom {
  inset: auto;
  bottom: anchor(top);
  right: anchor(left)
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 17px;
  top: 12px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(90px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.plan-side-popup>div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup>div:hover {
  background-color: #e4eaf9;
}

.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}
.tool-tip {
    right: 20px;
    top: 0px;
}
</style>
